import React from 'react';
import CustomButton from '../../CustomButton';

const SigningOrderControllers = ({ setShowSignateOrderModal, t, disabled }) => {
  return (
    <CustomButton
      size="small"
      disabled={disabled}
      onClick={() => setShowSignateOrderModal(true)}
    >
      {t('Configure Signing Order')}
    </CustomButton>
  );
};

export default SigningOrderControllers;
